function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.727 14H0v-1.091a2.727 2.727 0 012.727-2.727H6a2.727 2.727 0 012.727 2.727V14zM4.364 9.09a3.273 3.273 0 110-6.545 3.273 3.273 0 010 6.546z",
  fill: "#DFDFDF"
});

var SvgFindIconOff = function SvgFindIconOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgFindIconOff;